import React from 'react';
import './FlagButton.css';

/**
 * Reusable Flag Button Component
 * Displays a flag icon for reporting content
 *
 * @param {Object} props
 * @param {Function} props.onClick - Callback when flag is clicked
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {boolean} props.isFlagged - Whether content has been flagged by user
 * @param {string} props.size - 'small' | 'medium' | 'large'
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.title - Button title/tooltip
 */
const FlagButton = ({
  onClick,
  disabled = false,
  isFlagged = false,
  size = 'small',
  className = '',
  title = 'Report this content',
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`flag-button flag-button--${size} ${isFlagged ? 'flagged' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      title={isFlagged ? 'You have reported this content' : title}
      aria-label={title}
    >
      <i className={`bi ${isFlagged ? 'bi-flag-fill' : 'bi-flag'}`}></i>
    </button>
  );
};

export default FlagButton;
